import { Injectable } from '@angular/core';
import { Icon } from '../enums/icon';
import { IconEntryNotFoundException } from '../exceptions/icon-entry-not-found.exception';

@Injectable({
  providedIn: 'root',
})
export class IconCssProviderService {
  private readonly entries = new Map<Icon, string>([
    [Icon.Alphabet, 'bi bi-alphabet'],
    [Icon.ArrowDownUp, 'bi bi-arrow-down-up'],
    [Icon.ArrowRepeat, 'bi bi-arrow-repeat'],
    [Icon.Award, 'bi bi-award'],
    [Icon.BasketFill, 'bi bi-basket2-fill'],
    [Icon.Bell, 'bi bi-bell'],
    [Icon.BodyText, 'bi bi-body-text'],
    [Icon.Book, 'bi bi-book'],
    [Icon.Boxes, 'bi bi-boxes'],
    [Icon.BoxHeartFill, 'bi bi-box2-heart-fill'],
    [Icon.BoxSeam, 'bi bi-box-seam'],
    [Icon.BoxSeamFill, 'bi bi-box-seam-fill'],
    [Icon.BuildingGear, 'bi bi-building-gear'],
    [Icon.Calendar3, 'bi bi-calendar3'],
    [Icon.CardList, 'bi bi-card-list'],
    [Icon.CartX, 'bi bi-cart-x'],
    [Icon.CashCoin, 'bi bi-cash-coin'],
    [Icon.Chat, 'bi bi-chat'],
    [Icon.CheckCircle, 'bi bi-check-circle'],
    [Icon.CheckCircleFill, 'bi bi-check-circle-fill'],
    [Icon.ChevronDown, 'bi bi-chevron-down'],
    [Icon.ChevronLeft, 'bi bi-chevron-left'],
    [Icon.ChevronRight, 'bi bi-chevron-right'],
    [Icon.ChevronUp, 'bi bi-chevron-up'],
    [Icon.CloudDownloadFill, 'bi bi-cloud-download-fill'],
    [Icon.CloudUploadFill, 'bi bi-cloud-upload-fill'],
    [Icon.ColumnsGap, 'bi bi-columns-gap'],
    [Icon.Copy, 'bi bi-copy'],
    [Icon.Dash, 'bi bi-dash'],
    [Icon.Dash_LG, 'bi bi-dash-lg'],
    [Icon.EmojiHeartEyes, 'bi bi-emoji-heart-eyes'],
    [Icon.ExclamationCircleFill, 'bi bi-exclamation-circle-fill'],
    [Icon.Eye, 'bi bi-eye'],
    [Icon.Eyedropper, 'bi bi-eyedropper'],
    [Icon.Facebook, 'bi bi-facebook'],
    [Icon.FilePost, 'bi bi-file-post'],
    [Icon.Folder, 'bi bi-folder'],
    [Icon.GearWideConnected, 'bi bi-gear-wide-connected'],
    [Icon.GlobeAlt, 'bi bi-globe2'],
    [Icon.Google, 'bi bi-google'],
    [Icon.GraphUpArrow, 'bi bi-graph-up-arrow'],
    [Icon.GridFill, 'bi bi-grid-fill'],
    [Icon.HouseFill, 'bi bi-house-fill'],
    [Icon.Instagram, 'bi bi-instagram'],
    [Icon.List, 'bi bi-list'],
    [Icon.ListTask, 'bi bi-list-task'],
    [Icon.LockFill, 'bi bi-lock-fill'],
    [Icon.NodePlus, 'bi bi-node-plus'],
    [Icon.PauseCircle, 'bi bi-pause-circle'],
    [Icon.Pencil, 'bi bi-pencil'],
    [Icon.People, 'bi bi-people'],
    [Icon.PlayCircle, 'bi bi-play-circle'],
    [Icon.Plus, 'bi bi-plus'],
    [Icon.Plus_LG, 'bi bi-plus-lg'],
    [Icon.QuestionCircle, 'bi bi-question-circle'],
    [Icon.QuestionCircleFill, 'bi bi-question-circle-fill'],
    [Icon.Recycle, 'bi bi-recycle'],
    [Icon.SendArrowDown, 'bi bi-send-arrow-down-fill'],
    [Icon.ShieldLock, 'bi bi-shield-lock'],
    [Icon.Shop, 'bi bi-shop'],
    [Icon.Sliders, 'bi bi-sliders'],
    [Icon.Speedometer, 'bi bi-speedometer2'],
    [Icon.Square, 'bi bi-square'],
    [Icon.SquareHalf, 'bi bi-square-half'],
    [Icon.Star, 'bi bi-star'],
    [Icon.StarFill, 'bi bi-star-fill'],
    [Icon.StarHalf, 'bi bi-star-half'],
    [Icon.Tags, 'bi bi-tags'],
    [Icon.TextIndentLeft, 'bi bi-text-indent-left'],
    [Icon.TextIndentRight, 'bi bi-text-indent-right'],
    [Icon.TextParagraph, 'bi bi-text-paragraph'],
    [Icon.ThreeDots, 'bi bi-three-dots'],
    [Icon.ThreeDotsVertical, 'bi bi-three-dots-vertical'],
    [Icon.Trash, 'bi bi-trash'],
    [Icon.Truck, 'bi bi-truck'],
    [Icon.UnlockFill, 'bi bi-unlock-fill'],
    [Icon.X, 'bi bi-x'],
    [Icon.X_LG, 'bi bi-x-lg'],
    [Icon.XCircle, 'bi bi-x-circle'],
  ]);

  public getCss(icon: Icon): string {
    const result = this.entries.get(icon);

    if (result) {
      return result;
    }

    const name = Icon[icon];

    throw new IconEntryNotFoundException(`Not found entry for "${name}" name.`);
  }
}
